<template>
    <el-menu class="header" :default-active="activeIndex" mode="horizontal" @select="handleSelect" text-color="rgba(0,0,0,0.85)" active-text-color="#3361FF">
        <title>多盟轻推送-开发者平台</title>
        <div class="logo">
            <a href="/abroad">
                <img v-if="language == 'English'" src="@/assets/img/abroad_logo_en.png.png">
                <img v-else src="@/assets/img/abroad_logo_cn.png.png">
            </a>
        </div>
        <div class="topnav">
            <div class="menu">
                <!-- 一级菜单按权限收敛：底下一个有权限的页面都没有就整项不显示，
                     点进去也落在第一个有权限的二级页面 -->
                <el-menu-item
                    v-for="item in topMenus"
                    :key="item.key"
                    :index="item.path"
                    :disabled="item.key !== 'account' && isOverseasNewUser"
                >{{ item.label }}</el-menu-item>
            </div>
            <div class="header-right">
                <div class="header-user-con">
                    <el-dropdown class="lang" trigger="click" @command="langChange">
                        <span class="el-dropdown-link">
                            {{language}} <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
                            <el-dropdown-item divided  command="en">English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="user-name">
                        <!-- <div style="color: rgba(0,0,0,0.85); display: flex;"> -->
                            <el-dropdown @command="handleCommand" style="line-height: 75px;">
                                <span class="el-dropdown-link">
                                    <Icon name="user" class="svg-icon userIcon"/>
                                    <span>
                                        {{username}} <i class="el-icon-arrow-down" style="margin-left: 6px"></i>
                                    </span>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="custom-dropdown-width">
                                    <el-dropdown-item divided  command="reset">{{$t("login.forget")}}</el-dropdown-item>
                                    <el-dropdown-item divided  command="logout">{{$t('logout')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        <!-- </div> -->
                        <!-- <p style="color: rgba(0,0,0,0.85)">{{$t('menu.operator')}}{{operatorname}}</p> -->
                    </div>
                </div>
            </div>
        </div>
    </el-menu>
</template>
<script>
import util from '@/utils/util'
import perm from '@/utils/permission'
    export default {
        data() {
            return {
                path:'',
                collapse: false,
                fullscreen: false,
                name: '多盟轻推',
                language: '中文',
                isOverseasNewUser: false
            }
        },
        computed:{
            username(){
                let user = this.readUser()
                return user ? user.email: ""
            },
            operatorname(){
                let user = this.readUser()
                return user ? user.operatorEmail: ""
            },
            topMenus(){
                return perm.topMenus()
            },
            // 当前页不一定就是菜单项上挂的那个地址（广告位列表挂在「媒体」下面，
            // 但「媒体」这一项的 index 是应用列表），所以按归属的一级菜单来点亮
            activeIndex(){
                let key = perm.menuKeyByPath(this.$route.path)
                if (key) {
                    let topKey = perm.topKeyOf(key)
                    let hit = this.topMenus.filter(t => t.key === topKey)[0]
                    if (hit) return hit.path
                }
                return this.$route.path
            }
        },
        created(){
            this.path = this.$route.path;
            var lang = localStorage.getItem("lang")
            if(lang == 'en') {
                this.language = 'English'
            } else if (lang == 'zh') {
                this.language = '中文'
            }
            this.updateUserStatus();
            // 顶部导航是进后台后第一个渲染的东西，权限快照在这里兜底拉一次
            perm.load().catch(() => {})
            this.$eventBus.$on('companyUpdated', this.updateUserStatus);
        },
        beforeDestroy() {
            this.$eventBus.$off('companyUpdated', this.updateUserStatus);
        },
        methods:{
            // 中英文切换
            langChange(command) {
                this.$i18n.locale = command
                localStorage.setItem("lang", command)
                if(command == 'en') {
                    this.language = 'English'
                } else if (command == 'zh') {
                    this.language = '中文'
                }
                this.$eventBus.$emit("getLang",command)
            },
            handleCommand(command) {
                if(command == 'logout') {
                    // 清楚cookie，到登录页
                    util.delCookie("token");
                    util.delCookie("user");
                    // 权限快照是模块级缓存，退出时清掉，免得换账号登进来看到上一个人的菜单
                    perm.reset();
                    window.location.href = '/#/login';
                } else if (command == 'reset') {
                    this.$router.push('/reset');
                }
            },
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
           // user cookie 读坏了（被浏览器截断、旧版本留下的格式）不能让整个 header 渲染失败，
           // 当没有处理：用户名显示空，导航照常出来
           readUser() {
                try {
                    return JSON.parse(util.getCookie("user"))
                } catch (e) {
                    return null
                }
           },
           updateUserStatus() {
                const user = this.readUser()
                if (!user) {
                    this.isOverseasNewUser = false
                    return
                }
                this.isOverseasNewUser = user.verify_code === 0 && !user.old_user
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        width: 100%;
        font-size: 22px;
        color: #000;
        border-bottom:  1px solid #EBEBEB;
        display: flex;
        align-items: center;
    }
    .collapse-btn{
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 60px;
    }
    .header .logo {
        min-width: 200px;
        line-height: 64px;
        margin-left: 24px;
        flex-shrink: 0;
    }
    .header .logo a{
        color: #fff;
        width: 100%;
        /* float: left; */
        img{
            height: 30px;
        }
    }
    .topnav {
        display: flex;
        justify-content: space-between;
        margin-left: 46px;
        flex: 1;
        min-width: 0;
        padding-right: 24px;
    }
    .menu {
        height: 64px;
        display: flex;
        min-width: 0;
        flex-shrink: 1;
        overflow: hidden;
    }
    .menu .el-menu-item {
        height: 64px;
        line-height: 64px;
        padding: 0;
        margin: 0 18px;
    }
    .el-menu-item:focus, .el-menu-item:hover {
        background-color: transparent;
    }
    .header-right .doc-download{
        color:#000;
        font-size: 14px;
        padding: 0 20px;
        cursor: pointer;
    }
    .header-user-con{
        display: flex;
        height: 64px;
        align-items: center;
        flex-shrink: 0;
        white-space: nowrap;
    }
    .header-user-con .lang{
        min-width: 67px;
        text-align: right;
        flex-shrink: 0;
    }
    .header-user-con .logout {
        margin: 0 10px;
        font-size: 26px;
        font-weight: 700;
    }
    .header-user-con .logout:hover {
        color: #20a0ff;
    }
    .userIcon.icon {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }
    .btn-fullscreen{
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }
    .btn-bell, .btn-fullscreen{
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }
    .btn-bell-badge{
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }
    .btn-bell .el-icon-bell{
        color: #fff;
    }
    .user-name{
        margin-left: 10px;
        font-size: 14px;
        padding: 0 16px;
        flex-shrink: 0;
        white-space: nowrap;
    }
    .user-avator{
        margin-left: 20px;
    }
    .user-avator img{
        display: block;
        width:40px;
        height:40px;
        border-radius: 50%;
    }
    .user-name .el-dropdown-link{
        color: rgba(0,0,0,0.85);
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .el-dropdown-menu__item{
        text-align: center;
    }
    .el-menu-item.is-active {
        border-bottom: 2px solid #3361FF;
    }
    .custom-dropdown-width {
        min-width: 150px;
    }
</style>
